// src/pages/components/RequireAccess.js
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "pages/context/AuthContext";

/**
 * Guard de acesso por permissões.
 * - Espera pelo loading do AuthContext antes de decidir (evita saltar no F5).
 * - Redireciona para login se não autenticado.
 * - Redireciona para /auth/nao-autorizado se não tiver a permissão pedida.
 *
 * Props:
 *  - acesso: string  (nome do acesso/entrada de menu a verificar)
 *  - tipo:   'r'|'w'|'u'|'d'  (default 'r')
 */
export default function RequireAccess({ acesso, tipo = "r", children }) {
  const { authenticated, loading, temPermissao } = useAuth();
  const location = useLocation();

  // Enquanto a sessão está a hidratar do localStorage, não renders/redirects
  if (loading) return null; // ou um spinner/skeleton se preferires

  // Não autenticado → Login, preservando a localização para voltar depois
  if (!authenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Se não foi pedido nenhum "acesso", deixa passar
  if (!acesso) return children;

  // Sem permissão no tipo solicitado → página de não-autorizado
  if (!temPermissao(acesso, tipo)) {
    return <Navigate to="/auth/nao-autorizado" replace />;
  }

  // Acesso concedido
  return children;
}
